import { Component, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MonacoEditorModule } from '@vality/ng-monaco-editor';
import { TranslocoModule } from '@jsverse/transloco';

export enum SizingViewMode {
  FORM = 'FORM',
  JSON = 'JSON'
}

export interface SizingMetric {
  key: string;
  label: string;
  value: any;
  type: string;
  overrideAllowed: boolean;
}

export interface SizingSection {
  sectionTitle: string;
  metrics: SizingMetric[];
  isNested: boolean;
}

export interface SizingCard {
  component: string;
  title: string;
  sections: SizingSection[];
}

@Component({
  selector: 'app-sizing-content',
  templateUrl: './sizing-content.component.html',
  styleUrls: ['./sizing-content.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MonacoEditorModule,
    TranslocoModule
  ]
})
export class SizingContentComponent {
  @Input() sizingCards: SizingCard[] = [];
  @Input() currentView: SizingViewMode = SizingViewMode.FORM;
  @Input() searchTerm: string = '';
  @Input() isJsonLoading: boolean = false;
  @Input() jsonInput: any = { value: '', language: 'json' };
  @Input() editorOptions: any = {
    theme: 'light',
    language: 'json',
    automaticLayout: true,
    readOnly: true,
  };
  @Input() templateResponse: boolean;
  @Input() componentError: any;
  @Input() retrySizing: boolean;


  @Output() viewChanged = new EventEmitter<SizingViewMode>();
  @Output() searchChanged = new EventEmitter<string>();
  @Output() downloadRequested = new EventEmitter<void>();
  @Output() viewErrorDetails = new EventEmitter<void>();

  SizingViewMode = SizingViewMode;

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  /** Emits the selected view mode (FORM or JSON) to the parent component. */
  switchView(view: SizingViewMode): void {
    this.viewChanged.emit(view);
  }

  /** Emits the current search term to the parent component whenever the search input changes. */
  onSearchInput(): void {
    this.searchChanged.emit(this.searchTerm);
  }

  /** Emits a download request event to the parent component to trigger JSON file download. */
  downloadJson(): void {
    this.downloadRequested.emit();
  }
}
